<div class="d-flex justify-content-center">
  <div class="card  col-lg-10 col-md-10 col-sm-12 col-12 remove-curve">

    <div class="small-pad-left">
      <h2 class="pad">Who should we contact?</h2>
      <p class="no-bold">To complete your request(s) for review, we need to know who in your office to contact with
        additional questions or clarifications.
        Please complete the following information and attest with your signature below.</p>
      <p class="no-bold">All information is required, unless marked optional.</p>
    </div>
    <form class="needs-validation" [formGroup]="contactForm" novalidate>
      <p class="bold big-pad-left">Full Name</p>
      <div class="form-row">
        <div class="col-md-4 col-lg-4 col-5 pad-left">
          <label class="no-bold" for="contactName">First</label>
          <input type="text" class="form-control " id="contactName" formControlName="contactName" required>
          <p class="err"
            *ngIf="contactForm.controls.contactName.errors?.required && contactForm.controls.contactName.touched">
            First Name is required
          </p>
          <span class="err no-pad" *ngIf="contactForm.controls.contactName.errors?.pattern">
            Invalid character
          </span>
        </div>
        <div class="col-2 col-lg-1 col-md-1 ">
          <label class="no-bold lb" tooltip="Middle Initial (optional)" placement="top"
            for="contactMiddleInitial">M.I.</label>
          <input type="text" class="form-control" id="contactMiddleInitial" formControlName="contactMiddleInitial"
            maxlength="1">
          <span class="err no-pad abs" *ngIf="contactForm.controls.contactMiddleInitial?.errors?.pattern">
            Invalid character
          </span>
        </div>
        <div class="col-md-4  col-lg-4 col-5">
          <label class="no-bold" for="contactLastName">Last</label>
          <input type="text" class="form-control" id="contactLastName" formControlName="contactLastName" required>
          <p class="err"
            *ngIf="contactForm.controls.contactLastName.errors?.required && contactForm.controls.contactLastName.touched">
            Last Name is required
          </p>
          <p class="err no-pad" *ngIf="contactForm.controls.contactLastName?.errors?.pattern">
            Invalid character
          </p>
        </div>
      </div>

      <div class="dropdown top-pad">
        <div class="col-md-5 col-12 col-lg-4  mb-3">
          <label for="contactCountry">Country</label>
          <select class="custom-select " id="contactCountry" formControlName="contactCountry" required
            (click)="onCountryChange($event)">

            <option *ngFor="let country of countries | keyvalue: valueAscOrder" value="{{country.key}}">{{country.value
              | capital}}</option>
          </select>
          <p class="err"
            *ngIf="contactForm.controls.contactCountry.errors?.required && contactForm.controls.contactCountry.touched">
            Country is required
          </p>
        </div>
      </div>
      <div class="dropdown" *ngIf="contactForm.controls.contactCountry.value === 'US'">
        <div class="col-md-5 col-12 col-lg-4  mb-3 ">
          <label for="contactState">State</label>
          <select class="custom-select" id="contactState" formControlName="contactState">
            <option selected value="">- Select -</option>
            <option *ngFor="let state of states | keyvalue: valueAscOrder" value="{{state.key}}">
              {{ state.value | capital }}
            </option>
          </select>
          <p class="err"
            *ngIf="contactForm.controls.contactState.errors?.required && contactForm.controls.contactState.touched">
            State is required
          </p>

        </div>
      </div>
      <div class="mb-3 col-12">
        <label class="bold" for="phone">Phone</label>
        <input input type="text" class="col-md-4 col-lg-4  col-12 form-control" id="phone"
          formControlName="contactPhone" placeholder="10 digits" maxlength="18" minlength="8" appPhone="true" required>
        <p class="err no-pad"
          *ngIf="contactForm.controls.contactPhone?.errors?.required && contactForm.controls.contactPhone?.touched">
          Phone is required
        </p>
      </div>
      <div class="mb-3 col-12">
        <label class="bold" for="fax">FAX</label>
        <p class="optional-tag"> (optional)</p>
        <input input type="text" class="col-md-4 col-lg-4 col-12 form-control" id="fax" formControlName="contactFax"
          placeholder="10 digits" maxlength="18" appPhone="true">
      </div>
      <div class="mb-3 col-12">
        <label class="bold marg-bot" for="email">Email Address</label>
        <p class="optional-tag"> (optional)</p>
        <p class="no-bold col-8 no-left-pad no-pad">Provide email address to receive automated updates about your
          request.</p>
        <input type="text" class="col-md-4 col-lg-4 col-12 form-control" id="email" formControlName="contactEmail"
          placeholder="name@example.com">
        <p class="err no-pad" *ngIf="contactForm.controls.email?.errors?.email">
          Invalid email
        </p>
      </div>
      <div class="mb-3 col-12 capcha">
        <label class="bold" for="capcha">Verify Your Identity</label>
        <re-captcha (resolved)="handleCorrectCaptcha($event)"
          siteKey="6Lfxk80ZAAAAAFw1xEHTpXnTmCggyu0t_rlokT_z" id="capcha"></re-captcha>
      </div>
      <div id="sig">
        <label class="bold block black sig-pad" for="signature"> Signature</label>
        <input id="signature" type="checkbox" formControlName="contactSignature">
        <div class="flex">

          I certify under penalty of perjury that I am the individual named in this form, or I am a duly authorized
          representative acting on his/her behalf,
          and the information provided herein is accurate and complete to the best of my knowledge.
        </div>
      </div>

      <div class="whitespace"></div>
      <div class="buttons"> <button type="button" [disabled]="!contactForm.valid || !contactForm.touched || submitted"
          (click)="submit();" class="btn btn-primary btn-sm">{{submitText}}</button>
        <button type="button" (click)="exit();" class="btn btn-light btn-sm blue-cir">Exit</button>
      </div>
    </form>
  </div>
</div>